module.exports = __webpack_public_path__ + "img/music-player-play.f98cb8a8.svg";